import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: transparent;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  input,
  button,
  select {
    outline: none;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  a {
    color: #ff6b35;
  }

  html {
    height: 100%;
    /* font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25% */
    box-sizing: border-box;

    @media screen and (max-width: 1200px) {
      font-size: 85%; //1rem = 8px, 8/16 = 50%
    }

    @media screen and (max-width: 768px) {
      font-size: 75%; //1rem = 8px, 8/16 = 50%
    }
  }
  body {
    font-family: "Poppins-Regular", sans-serif;
    box-sizing: border-box;
    background: #2c2c2c;
    color: #ffffff;
    line-height: 1.6;
    user-select: none;
    outline: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: "Poppins-Bold", sans-serif;
  }

  p,
  span,
  a,
  li {
    font-family: "Poppins-Regular", sans-serif;
  }

  button {
    font-family: "Poppins-SemiBold", sans-serif;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    z-index: 2;
    cursor: pointer;
    background-color: red;
    position: absolute;
    right: 0.8rem;
    width: 15px;
    height: 15px;
  }

  input[type="time"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    z-index: 2;
    cursor: pointer;
    background-color: red;
    position: absolute;
    right: 0.8rem;
    width: 15px;
    height: 15px;
  }

  select {
    -webkit-appearance: none; /* Safari, Chrome */
    -moz-appearance: none; /* Firefox */
    appearance: none; /* Standard */
    background: none; /* skida default pozadinu */
  }

  /* Ako hoćeš i da ukloniš strelicu u Internet Explorer/Edge starijem */
  select::-ms-expand {
    display: none;
  }

  input {
    position: relative;
  }
  input[type="checkbox"] {
    appearance: none; /* skida default izgled */
    -webkit-appearance: none;
    -moz-appearance: none;

    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1.5px solid #ff6b35;
    background-color: transparent;
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"]:checked {
    background-color: #ff6b35;
    border-color: #ff6b35;
  }

  input[type="checkbox"]:checked::after {
    content: "✔";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    color: #000; /* crni checkmark */
  }
`;

export default GlobalStyles;

/* MEDIA QUERY MANAGER 
0 - 600px:  Phone
600 - 900px:  Tablet portrait
900 - 1200px:  Tablet landscape
[1200 - 1800] is where our normal styles apply
1800px+ :  Big desktop
*/
